<template>
  <div>
    <div class="md-layout-item md-small-size-100">
      <md-field :class="getValidationClass('intervalo')">
        <label :for="`intervalo${_uid}`"> Intervalo de envio (minutos) </label>
        <md-input
          v-model.number="form.intervalo"
          type="number"
          name="intervalo"
          :for="`intervalo${_uid}`"
          @input="() => handleChange()"
        />
        <span v-if="$v.form.intervalo.required" class="md-error"
          >Campo Obrigatório</span
        >
        <span v-if="$v.form.intervalo.minValue" class="md-error">
          Valor deve ser maior que zero
        </span>
      </md-field>

      <md-switch
        v-model="form.deveExecutarComandos"
        @change="() => handleChange()"
      >
        Executar comandos
      </md-switch>
      <md-switch
        v-model="form.deveExecutarComandosAutomaticos"
        @change="() => handleChange()"
      >
        Comandos Automáticos
      </md-switch>

      <div class="md-layout-item">
        <md-field :class="getValidationClass('envioDados')">
          <label for="envioDados">Tipo de envio</label>
          <md-select
            id="envioDados"
            v-model="form.envioDados"
            name="envioDados"
            @md-selected="() => handleChange()"
          >
            <md-option :value="400"> Não Enviar dados </md-option>
            <md-option :value="401"> SMS </md-option>
            <md-option :value="402"> GPRS </md-option>
            <md-option :value="403"> 4G </md-option>
            <md-option :value="404"> WIFI </md-option>
            <md-option :value="405"> SIM800L + WIFI </md-option>
            <md-option :value="406"> Travar Envio </md-option>
          </md-select>
          <span v-if="$v.form.envioDados.required" class="md-error"
            >Campo Obrigatório</span
          >
        </md-field>
      </div>

      <md-field :class="getValidationClass('pulso')">
        <label :for="`pulso${_uid}`"> Pulso </label>
        <md-input
          v-model.number="form.pulso"
          type="number"
          name="pulso"
          :for="`pulso${_uid}`"
          @input="() => handleChange()"
        />
        <span v-if="$v.form.pulso.required" class="md-error"
          >Campo Obrigatório</span
        >
        <span v-if="$v.form.pulso.minValue" class="md-error">
          Valor deve ser maior que zero
        </span>
      </md-field>

      <md-switch
        v-model="form.radioFrequenciaHabilitado"
        @change="() => handleChange()"
      >
        Rádio Frequência
      </md-switch>
      <md-switch
        v-model="form.radioFrequenciaEfrrfHabilitado"
        @change="() => handleChange()"
      >
        Rádio Frequência EFR-RF
      </md-switch>

      <md-field :class="getValidationClass('pinagemReleBombas')">
        <label :for="`pinagemReleBombas${_uid}`"> Pinagem Motobomba </label>
        <md-input
          v-model="form.pinagemReleBombas"
          name="pulso"
          :for="`pinagemReleBombas${_uid}`"
          @input="() => handleChange()"
        />
        <span v-if="$v.form.pinagemReleBombas.required" class="md-error"
          >Campo Obrigatório</span
        >
      </md-field>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import equipamentoMixin from '@/mixins/equipamento.mixin'

export default {
  name: 'MotoBombaEquipamentoConfig',
  mixins: [validationMixin, equipamentoMixin],
  props: {
    config: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      form: {
        intervalo: 5,
        deveExecutarComandos: false,
        envioDados: 403,
        deveExecutarComandosAutomaticos: false,
        pulso: 1,
        radioFrequenciaHabilitado: false,
        radioFrequenciaEfrrfHabilitado: false,
        pinagemReleBombas: '',
      },
    }
  },
  validations: {
    form: {
      pinagemReleBombas: {
        required,
      },
      intervalo: {
        required,
        minValue: (value) => value > 0,
      },
      pulso: {
        required,
        minValue: (value) => value > 0,
      },
      envioDados: {
        required,
      },
    },
  },
  beforeMount() {
    this.form.intervalo = this.getConfigValue(
      this.config,
      'IntervaloMotoBombaConfig',
      'intervalo',
      5
    )
    this.form.deveExecutarComandos = this.getConfigValue(
      this.config,
      'ExecutarComandosConfig',
      'deveExecutar',
      false
    )
    this.form.deveExecutarComandosAutomaticos = this.getConfigValue(
      this.config,
      'ExecutarComandosAutomaticosConfig',
      'deveExecutar',
      false
    )
    this.form.envioDados = this.getConfigValue(
      this.config,
      'EnvioDadosConfig',
      'tipoEnvio',
      403
    )
    this.form.pulso = this.getConfigValue(
      this.config,
      'PulsoConfig',
      'pulso',
      1
    )

    this.form.radioFrequenciaHabilitado = this.getConfigValue(
      this.config,
      'RadioFrequenciaConfig',
      'habilitado',
      false
    )
    this.form.radioFrequenciaEfrrfHabilitado = this.getConfigValue(
      this.config,
      'RadioFrequenciaEfrrfConfig',
      'habilitado',
      false
    )

    this.form.pinagemReleBombas = this.getConfigValue(
      this.config,
      'PinagemReleBombasConfig',
      'pinagem',
      ''
    )

    this.handleChange()
  },
  methods: {
    handleChange() {
      this.$v.$touch()

      this.$emit('change', {
        form: {
          IntervaloMotoBombaConfig: {
            intervalo: this.form.intervalo,
          },
          ExecutarComandosConfig: {
            deveExecutar: this.form.deveExecutarComandos,
          },
          ExecutarComandosAutomaticosConfig: {
            deveExecutar: this.form.deveExecutarComandosAutomaticos,
          },
          EnvioDadosConfig: {
            tipoEnvio: this.form.envioDados,
          },
          PulsoConfig: {
            pulso: this.form.pulso,
          },
          RadioFrequenciaConfig: {
            habilitado: this.form.radioFrequenciaHabilitado,
          },
          RadioFrequenciaEfrrfConfig: {
            habilitado: this.form.radioFrequenciaEfrrfHabilitado,
          },
          PinagemReleBombasConfig: {
            pinagem: this.form.pinagemReleBombas,
          },
        },
        valid: this.$v.$valid,
      })
    },
  },
}
</script>

<style scoped lang="scss"></style>
